export default "__VITE_ASSET__DqXp2brK__"